import React, { useState, useEffect } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import productService from "../services/product";
import keys from "../store/keys";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import utils from "../utils/utils";
import { swalError, swalSuccess, swalInfo, swalConfirm } from "../utils/swal";
import wishlistService from '../services/wishlist';
import { v4 as uuid } from "uuid";
import RecommendedProducts from "./RecommendedProducts";
import moment from "moment";

function ProductDetails({ session, setKey, ...props }) {
	const [redirectTo, setRedirectTo] = useState(null);
	const [categories, setCategories] = useState([]);
	const [brands, setBrands] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState([]);
	const [selectedBrands, setSelectedBrands] = useState([]);
	const [product, setProduct] = useState(null);
	const [images, setImages] = useState([]);
	const [variants, setVariants] = useState([]);
	const [selectedVariant, setSelectedVariant] = useState(null);
	const [isMyFavorite, setIsMyFavorite] = useState(false);
	const [favouriteId, setFavoriteId] = useState(null);

	useEffect(() => {
		if (props.match.params.productId) {
			setKey(keys.isLoading, true);
			const productId = props.match.params.productId;
			const currency = session.selectedRegion ? session.selectedRegion.currency : "EUR";
			productService.getById(productId, currency)
				.then(result => {
					if (result.error) {
						swalError(result.error);
						setKey(keys.isLoading, false);
						return;
					}

					setKey(keys.isLoading, false);
					setProduct(result.data);
					let v = result.data.variants.sort((a, b) => a.price - b.price);
					setVariants(v);
					setSelectedVariant(v[0]);
					if (result.data && result.data.images && result.data.images.length > 0) {
						let images = result.data.images.map(image => {
							return {
								...image,
								original: image.fileUrl,
								thumbnail: image.fileUrl
							};
						});
						setImages(images);
					}
				});
		}
	}, [props.match.params.productId, session.selectedRegion]);

	useEffect(() => {
		checkIsMyFavorite();
	}, [props.match.params.productId]);

	const handleChangeVariant = (e, obj) => {
		e.preventDefault();
		document.querySelectorAll(`.btn-size`).forEach(k => k.style.borderColor = "#eee");
		e.target.style.borderColor = "#000";
		setSelectedVariant(obj);
	}

	const checkIsMyFavorite = async () => {
		if(!session.token) return;
		if (props.match.params.productId) {
			const productId = props.match.params.productId;
			await wishlistService.check(session.token, productId)
				.then(result => {
					if (result.error) return;

					if (result.data.favourite) {
						setFavoriteId(result.data.favourite._id);
						setIsMyFavorite(true);
					} else {
						setIsMyFavorite(false);
					}
				});
		}
	}

	const handleRemoveFavorite = e => {
		e.preventDefault();
		if (favouriteId) {
			swalConfirm({
				title: `Are you sure you want to remove it?`,
				callback: () => {
					wishlistService.remove(session.token, favouriteId)
						.then(result => {
							if (result.error) {
								swalInfo(result.error);
								return;
							}

							swalSuccess(`Product removed successfully!`);
							setIsMyFavorite(false);
							setFavoriteId(null);
						});
				}
			});
		}
	}

	const handleMakeFavorite = e => {
		e.preventDefault();
		if(!session.token) {
			swalInfo(`Please login first.`);
			return;
		}
		const productId = props.match.params.productId;
		wishlistService.create(session.token, productId)
			.then(result => {
				if (result.error) {
					swalInfo(result.error);
					return;
				}

				swalSuccess(`Product added successfully!`);
				setIsMyFavorite(true);
				setFavoriteId(result.data);
			});
	}

	const handleAddToCart = e => {
		e.preventDefault();
		if(!session.token) {
			swalInfo(`Please login first.`);
			return;
		}
		let t = JSON.parse(localStorage.getItem(keys.cart)) || [];
		t.push({
			id: uuid(),
			quantity: 1,
			currency: session.selectedRegion ? session.selectedRegion.currency : "EUR",
			product: product,
			selectedVariant: selectedVariant
		});
		localStorage.setItem(keys.cart, JSON.stringify(t));
	}

	const handleHome = e => {
		e.preventDefault();
		document.querySelector(`.nav-categories .browse-all a`).click();
	}

	const handleCategory = (e, cat) => {
		e.preventDefault(); 
        
		const id = `nav-link-${utils.replaceAll(" ", "", cat)}`.toLowerCase();
        document.querySelectorAll(`.nav-categories .nav-item`).forEach(k => k.classList.remove("nav-categories-active"));
        document.querySelector(`.nav-categories .browse-all`).classList.remove("nav-categories-active");
		document.querySelector(`.nav-categories #${id}`).click();
	}

	const handleSubCategory = (e, cat, sub) => {
		e.preventDefault();
		setKey(keys.searchCategories, ``); 
		setKey(keys.searchCategories, sub); 
		const id = `nav-link-${utils.replaceAll(" ", "", cat)}`.toLowerCase();
        document.querySelectorAll(`.nav-categories .nav-item`).forEach(k => k.classList.remove("nav-categories-active"));
        document.querySelector(`.nav-categories .browse-all`).classList.remove("nav-categories-active");
		document.querySelector(`.nav-categories #${id}`).classList.add("nav-categories-active");
		// document.querySelector(`.nav-categories #${id}`).click();
		setRedirectTo("/");
	}

	const renderBreadcrumbs = () => {
		const length = product.subCategories.split("|").length;
		return (<>
			<span onClick={handleHome}>Home</span>
			<i className="fa-solid fa-chevron-right"></i>
			<span onClick={e => handleCategory(e, product.categories)}>{product.categories}</span>
			<i className="fa-solid fa-chevron-right"></i>
			{product.subCategories.split("|").map((k, idx) => {
				if (idx < length - 1) {
					return <span key={idx} onClick={e => handleSubCategory(e, product.categories, k)}>{k}<i className="fa-solid fa-chevron-right"></i></span>
				}
				else {
					return <span key={idx} onClick={e => handleSubCategory(e, product.categories, k)}>{k}</span>
				}
			})}
		</>);
	}

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			{
				product &&
				<div className="container product-details">
					<div className="row mt-30">
						<div className="col-6">
							<ImageGallery
								items={images}
								thumbnailPosition={'left'}
								isRTL={false}
								showBullets={false}
								showIndex={false}
								showPlayButton={false}
								showFullscreenButton={false}
								showNav={true}
								autoPlay={false}
								renderLeftNav={(onClick, disabled) => {
									return (
										<button
											type="button"
											className="image-gallery-icon image-gallery-left-nav"
											disabled={disabled}
											onClick={onClick}
											aria-label="Previous Slide"
										>
											<i className="fa-solid fa-circle-chevron-left"></i>
										</button>
									)
								}}
								renderRightNav={(onClick, disabled) => {
									return (
										<button
											type="button"
											className="image-gallery-icon image-gallery-right-nav"
											disabled={disabled}
											onClick={onClick}
											aria-label="Next Slide"
										>
											<i className="fa-solid fa-circle-chevron-right"></i>
										</button>
									)
								}}
							/>
							<div className="breadcrumbs mt-20 mb-30" style={{paddingLeft: 110}}>
								{renderBreadcrumbs()}
							</div>
						</div>
						<div className="col-1"></div>
						<div className="col-4">
							<div className="row">
								<div className="brand">{product.brandId.title}</div>
							</div>
							<div className="row mt-10">
								<div className="title">{product.title}</div>
							</div>

							<div className="row mt-10">
								{selectedVariant && <div className="price">{utils.formatToCurrency(selectedVariant.price, session.selectedRegion ? session.selectedRegion.currency : "EUR")}</div>}
							</div>

							<div className="row mt-10">
								<div className="col-1 mt-10">
									<i className="fa-solid fa-check" style={{fontSize: 20}}></i>
								</div>
								<div className="col-11">
									<div>Delivery to: <span className="text-uppercase cart-title">{session.selectedRegion ? session.selectedRegion.code : "Netherlands"}</span></div>
									<div>{moment().add(product.deliveryDays, 'days').format("DD MMMM YYYY")}</div>
								</div>
							</div>

							<div className="row mt-10">
								<div>Size:</div>
								{
									variants &&
									<div className="btn-sizes">
										{
											variants.map(k => <button key={k._id} className="btn btn-light btn-sm btn-size" onClick={e => handleChangeVariant(e, k)}>{k.size}</button>)
										}
									</div>
								}
							</div>
							<button className="btn btn-dark w-100 mt-30" onClick={handleAddToCart}>Add to Bag</button>
							{
								isMyFavorite === true &&
								<button className="btn btn-light w-100 mt-10" style={{ border: "1px solid #000" }} onClick={handleRemoveFavorite}>Remove from Wish List</button>
							}
							{
								isMyFavorite === false &&
								<button className="btn btn-light w-100 mt-10" style={{ border: "1px solid #000" }} onClick={handleMakeFavorite}>Add to Wish List</button>
							}

							<h6 className="mt-30">Description</h6>
							<div className="mb-30">
								{product.description}
							</div>
						</div>
						<div className="col-1"></div>
					</div>
					<hr/>
					{product && <RecommendedProducts data={product} />}
				</div>
			}
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
